import {createSlice} from '@reduxjs/toolkit'
import FormHelper from '../../utils/forms'
import CustomerService from '../../api/customer'
import {toast} from 'react-toastify'

export const feedbackSlice = createSlice({
    name: 'feedback',
    initialState: {
        feedbackModalIsActive: false
    },
    reducers: {
        setFeedbackModalIsActive: (state, {payload}) => {
            state.feedbackModalIsActive = payload
        }

    }
})

export const {
    setFeedbackModalIsActive
} = feedbackSlice.actions

export default feedbackSlice.reducer

export const addFeedback = (formData, setFieldError, resetForm, callback) => {
    return async dispatch => {
        try {
            const {data} = await CustomerService.addFeedback(formData)
            resetForm()
            callback()
            toast.success(data?.message)
        } catch (e) {
            const fields = e?.response?.data?.data?.fields
            FormHelper.setFormElementError(fields, setFieldError, dispatch)
        }
    }
}
